import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-temporary-contractor-icon',
  templateUrl: './temporary-contractor-icon.component.html',
  styleUrls: ['./temporary-contractor-icon.component.scss'],
  standalone: true,
})
export class TemporaryContractorIconComponent implements OnInit {
  constructor() {}

  ngOnInit(): void {}
}
